import { useState, useEffect } from "react"

// Hook personalizado para detectar breakpoints de mídia
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(false)

  useEffect(() => {
    const mediaQuery = window.matchMedia(query)
    
    // Definir o valor inicial
    setMatches(mediaQuery.matches)
    
    // Criar um listener para atualizar o estado quando o tamanho da tela mudar
    const handler = (event: MediaQueryListEvent) => {
      setMatches(event.matches)
    }
    
    // Adicionar o listener
    mediaQuery.addEventListener("change", handler)
    
    // Limpar o listener quando o componente for desmontado
    return () => {
      mediaQuery.removeEventListener("change", handler)
    }
  }, [query])
  
  return matches
}

// Hooks pré-configurados para breakpoints comuns
export function useIsMobile(): boolean {
  return useMediaQuery("(max-width: 600px)")
}

export function useIsTablet(): boolean {
  return useMediaQuery("(min-width: 601px) and (max-width: 960px)")
}

export function useIsDesktop(): boolean {
  return useMediaQuery("(min-width: 961px)")
}

export function useIsMobileOrTablet(): boolean {
  return useMediaQuery("(max-width: 960px)")
}
